import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-premium',
  templateUrl: './premium.component.html',
  styleUrls: ['./premium.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PremiumIconComponent {}
